module.exports = __webpack_public_path__ + "img/cz.88fdd9d5.png";